import { useNostoAppState, useSizeOptions } from "@nosto/search-js/preact/hooks"
import { pick } from "@nosto/search-js/utils"
import { defaultSize, sizes, styleFamilyCatalogMaxRawTotal } from "@/config"
import Icon from "@/elements/Icon/Icon"
import style from "./Toolbar.module.css"
import { cl } from "@nosto/search-js/utils"
import { useFilterSidebar } from "@/contexts/SidebarContext"
import { useStyleFamilyCatalog } from "@/contexts/StyleFamilyCatalogContext"

type Props = {
  className?: string
}

function formatTotal(total: number, exact: boolean): string {
  const noun = total === 1 ? "product" : "products"
  return exact ? `${total} ${noun}` : `About ${total} ${noun}`
}

// The count of selected filters used to live in a `(N)` badge on this trigger,
// but the applied-filter bar above the grid now shows the
// full list of pills + heading count, so the badge is removed to avoid the
// duplicate signal.
function FilterSortTrigger({ className }: Props) {
  const { toggle } = useFilterSidebar()

  return (
    <button
      type="button"
      className={cl(style.trigger, className)}
      onClick={toggle}
      data-filter-drawer-trigger=""
    >
      <span className={style.triggerText}>
        <span className={style.triggerLabel}>Filter &amp; Sort</span>
      </span>
      <Icon name="plus" className={style.triggerIcon} />
    </button>
  )
}

export default function Toolbar() {
  const { loading } = useNostoAppState(state => pick(state, "loading"))
  const { total: nostoTotal } = useSizeOptions(sizes, defaultSize)
  const catalog = useStyleFamilyCatalog()

  const exactTotal = catalog?.status === "ready" && catalog.dedupedHits ? catalog.dedupedHits.length : null
  const displayTotal = exactTotal ?? nostoTotal
  const catalogPriming =
    catalog != null &&
    catalog.rawTotal > 0 &&
    catalog.rawTotal <= styleFamilyCatalogMaxRawTotal &&
    (catalog.status === "loading" || catalog.status === "idle")

  return (
    <div className={cl(style.container, loading && style.loading)}>
      <div className={style.leftSide}>
        <FilterSortTrigger />
      </div>
      <div className={style.rightSide}>
        {!loading && !catalogPriming && (
          <span className={style.total} data-nosto-element="totalResults">
            {formatTotal(displayTotal, exactTotal !== null)}
          </span>
        )}
      </div>
    </div>
  )
}
